function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgTagSale(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "uc-svg": "uc-tag"
  }, props), React.createElement("path", {
    d: "M22 7l-.017 10H2l.005-10H22zM6.019 9.607h-.087c-.457.022-.827.153-1.11.414-.304.282-.456.652-.456 1.087 0 .37.13.696.37.957.186.205.468.362.805.444l.412.078.327.044c.26.043.348.13.348.326 0 .217-.174.348-.61.348-.353 0-.66-.096-.932-.274l-.133-.096-.196-.152-.761.848.196.152.065.066c.5.391 1.066.587 1.74.587 1.11-.022 1.74-.522 1.784-1.5 0-.349-.131-.675-.348-.958-.218-.283-.588-.457-1.045-.522l-.231-.027-.095-.016-.152-.022c-.152-.022-.261-.065-.326-.13-.065-.066-.087-.11-.087-.175 0-.13.043-.195.109-.26a.553.553 0 01.348-.11c.29 0 .55.061.791.195l.144.088.196.131.674-.914-.196-.13-.087-.043c-.362-.248-.79-.379-1.255-.422l-.202-.014zm4.589-.021h-.892l-1.74 4.806h1.218l.348-.957h1.284l.326.957h1.196l-1.74-4.806zm3.35.021h-1.153v4.786h3.24v-1.11h-2.088V9.608zm6.046 0h-3.24v4.786h3.24v-1.11h-2.088v-.761H19.7v-1.066h-1.784v-.74h2.088V9.609zM10.173 11.5l.283.87H9.89l.283-.87z"
  }));
}

SvgTagSale.clsName = 'icon-uc-tag__tag-sale';
SvgTagSale.remarkName = 'unknown';
export default SvgTagSale;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/uc-tag/svgr/TagSale.js
// module id = 2086
// module chunks = 6 7 17 18